import React, { useState } from 'react';
import { useLazyQuery, gql } from '@apollo/client';
import { Box, TextField, Button, Typography } from '@mui/material';

const CHAT_QUERY = gql`
  query Chat($message: String!) {
    chatbot(message: $message) {
      response
      sourceDocuments {
        source
        page
      }
    }
  }
`;

const ChatbotView = () => {
  const [message, setMessage] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  const [fetchChat, { loading, data }] = useLazyQuery(CHAT_QUERY, {
    onCompleted: (data) => {
      setChatHistory([...chatHistory, { message, response: data.chatbot.response, sourceDocuments: data.chatbot.sourceDocuments }]);
      setMessage('');
    },
  });

  const handleSendMessage = () => {
    fetchChat({ variables: { message } });
  };

  return (
    <Box sx={{ padding: '2rem' }}>
      <Typography variant="h4" gutterBottom>
        Chatbot
      </Typography>
      <Box sx={{ marginBottom: '1rem' }}>
        <TextField
          fullWidth
          label="Type your message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') handleSendMessage();
          }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSendMessage}
          disabled={loading}
          sx={{ marginTop: '1rem' }}
        >
          Send
        </Button>
      </Box>
      <Box>
        {chatHistory.map((chat, index) => (
          <Box key={index} sx={{ marginBottom: '1rem' }}>
            <Typography variant="body1"><strong>You:</strong> {chat.message}</Typography>
            <Typography variant="body1"><strong>Bot:</strong> {chat.response}</Typography>
            {chat.sourceDocuments && chat.sourceDocuments.map((doc, idx) => (
              <Typography key={idx} variant="body2" color="textSecondary">
                Source: {doc.source}, Page: {doc.page}
              </Typography>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ChatbotView;